import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.members/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMembersComponent implements OnInit {
    public loading: boolean = false;
    public members: any[] = [];

    public search: any = {
        text: "",
        role: ""
    };

    public roles: string[] = ['admin', 'editor', 'viewer'];

    public showInviteModal: boolean = false;
    public inviteData: any = { email: '', role: 'viewer' };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list", this.search);
        if (code === 200) {
            this.members = data || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.search.role = this.search.role === role ? "" : role;
        await this.load();
    }

    public async openInvite() {
        this.inviteData = { email: '', role: 'viewer' };
        this.showInviteModal = true;
        await this.service.render();
    }

    public async invite() {
        if (!this.inviteData.email) {
            await this.service.modal.error("이메일을 입력해주세요.");
            return;
        }

        const { code, data } = await wiz.call("invite", this.inviteData);
        if (code === 200) {
            await this.service.modal.success("초대가 완료되었습니다.");
            this.showInviteModal = false;
            await this.load();
        } else {
            await this.service.modal.error(data || "초대에 실패했습니다.");
        }
    }

    public async removeMember(member: any) {
        let res = await this.service.modal.show({
            title: "멤버 제거",
            message: `${member.name}님을 멤버에서 제거하시겠습니까?`,
            action: "제거",
            actionBtn: "error",
            status: "error"
        });
        if (!res) return;

        const { code } = await wiz.call("remove", { id: member.id });
        if (code === 200) {
            await this.load();
        }
    }

    public roleClass(role: string) {
        switch (role) {
            case 'admin': return 'bg-purple-100 text-purple-700';
            case 'editor': return 'bg-blue-50 text-blue-700';
            case 'viewer': return 'bg-zinc-100 text-zinc-600';
            default: return 'bg-zinc-100 text-zinc-600';
        }
    }
}

export default PageMembersComponent;